export default __webpack_public_path__ + "static/media/blue02.aeeba4e4.png";